import { useQuery } from "@tanstack/react-query";
import { EvidenceProgressAPI } from "./evidence-progress.api";

const evidenceProgressQueryKeys = {
  list: () => ["evidence-progress", "list"],
  infiniteList: () => ["evidence-progress", "infinite-list"],
  details: (id: number) => ["evidence-progress", "list", { id }],
};

const useGetEvidenceProgress = () => {
  return useQuery({
    queryKey: evidenceProgressQueryKeys.list(),
    queryFn: () => EvidenceProgressAPI.get(),
    staleTime: 10000, // 10 seconds
  });
};

export const EvidenceProgressQuery = {
  queryKeys: evidenceProgressQueryKeys,
  useGetEvidenceProgress,
};
